



























import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import LoadingIndicator from '@components/LoadingIndicator'
import EventScheduleSelector from '@ui/EventSchedule/EventScheduleSelector'
import CheckoutWizard from '@ui/CheckoutWizard/CheckoutWizard'
import AddPurchaseDiscountTriggerModal from '@triggers/CheckoutWizard/AddPurchaseDiscountTriggerModal'

settings =
  name: 'BrandRepShoppingCarts'

  components: {
    SuperContainerView,
    LoadingIndicator,
    EventScheduleSelector,
    CheckoutWizard,
    AddPurchaseDiscountTriggerModal
  }

  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'event_schedules/:selectedSchedule.id/shopping_cart'
      fetch: false

  vue:
    props: ['brandRepId']

    data: ->
      selectedSchedule: null

    computed:
      org: -> @ctxSponsorOrg(@selectedSchedule) || {}
      brandRep: -> @ctxOwner(@selectedSchedule) || {}

    methods:
      onSelectEventSchedule: (@selectedSchedule) ->
        @fetch('cart')

      addPurchaseDiscountTrigger: (lineItem) ->
        @$refs.addPurchaseDiscountTrigger.fire()
      onCartAddPurchaseDiscount: ->
        @fetch('cart')
        @$refs.addPurchaseDiscountTrigger.close()

export default VueOptions.vue settings
